// components
import Badger from '@/components/common/Badger';
// import Modal from "@/components/common/Modal";

export default function Portals() {
  return (
    <>
      <Badger />
      {/* <Modal /> */}
    </>
  );
}
